import { Node, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import useViewport from "@/hooks/use-viewport";
import getViewportValue from "@/utils/get-viewport-value";

type AboutDetailsListProps = {
  children: React.ReactNode;
};

const isNodeAllowed = (type) => ["AboutDetailsItem"].includes(type);

export default function AboutDetailsList(props: AboutDetailsListProps) {
  const {
    connectors: { connect, drag },
  } = useNode();
  const viewport = useViewport();

  const listStyle = React.useMemo(() => {
    return {
      display: "grid",
      gridTemplateColumns: getViewportValue(
        ["1fr", "1fr 1fr", "1fr 1fr 1fr"],
        viewport
      ),
      gap: getViewportValue(
        [rem(24), `${rem(40)} ${rem(24)}`, `${rem(40)} ${rem(24)}`],
        viewport
      ),
    };
  }, [viewport]);

  return (
    <div ref={(ref) => connect(drag(ref))} style={listStyle}>
      {props.children}
    </div>
  );
}

AboutDetailsList.craft = {
  rules: {
    canMoveIn: (nodes: Node[]) => {
      const nodeTypes = nodes?.map((node) => node?.type);
      return nodeTypes.length > 0 && nodeTypes.every(isNodeAllowed);
    },
  },
};
